import { Component, Input, OnInit } from '@angular/core';
import { CorrespondenceInterface } from '@app/core/interfaces/correspondence.interface';

@Component({
    selector: 'ins-correspondence',
    templateUrl: './correspondence.component.html',
})
export class CorrespondenceComponent implements OnInit {
    @Input() correspondence: CorrespondenceInterface;
    @Input() correspondenceIndex: number;
    @Input() isMobile: boolean;
    public row: boolean = false;
    public isOpen: boolean = false;

    ngOnInit(): void {
        this.isOpen = this.correspondenceIndex === 0;
    }

    public getToggleState(): string {
        if (this.row) {
            return 'rack__row--show';
        } else {
            return 'rack__row--hide';
        }
    }

    public toggleRow(): boolean {
        this.row = (!this.row);
        return false;
    }

    public toggle(): void {
        this.isOpen = !this.isOpen;
    }
}
